import { takeEvery, call, put, all, fork, select } from "redux-saga/effects";
import { SEND_MESSAGE, actionCreators } from "./action";
import { actionCreators as actionCreatorsSpinner } from "../Spinner/action";
import { enumChecker } from "../../common/helpers/checker";
import reduxSagaFirebase from "../../common/reduxSagaFirebase";

export function* onSendMessageContactSaga(action) {
  const { messageName, messageBox } = action.payload;

  if (messageName) {
    yield put(actionCreators.saveErrorReponse(null));

    if (messageBox) {
      yield put(actionCreatorsSpinner.showSpinner());

      const uid = yield select((state) => state.user.user.uid);
      const date = new Date();

      yield call(reduxSagaFirebase.database.create, `messages/${uid}`, {
        name: messageName,
        message: messageBox,
        date: date.toString(),
      });

      yield action.payload.redirect();
      // yield put(actionCreators.saveErrorReponse(null));
      yield put(actionCreatorsSpinner.hideSpinner());
    } else {
      const error = {
        code: enumChecker.emptyMessageBox,
        message: "This field cannot be empty",
      };
      //  yield put(actionCreatorsSpinner.showSpinner());
      yield put(actionCreators.saveErrorReponse(error));
      //  yield put(actionCreatorsSpinner.hideSpinner());
    }
  } else {
    const error = {
      code: enumChecker.emptyNameMessageBox,
      message: "This field cannot be empty",
    };
    //  yield put(actionCreatorsSpinner.showSpinner());
    yield put(actionCreators.saveErrorReponse(error));
    //  yield put(actionCreatorsSpinner.hideSpinner());
    return;
  }

  // const dataString = yield call(AsyncStorage.getItem, "authUserData");
  // const data = JSON.parse(dataString);

  // // console.log(data)
  // if (data !== null) {
  //   yield put(actionCreators.loginSuccess(data));
  //   yield call(action.payload.redirect, routes.Home);
  // }
}

export function* sendMessageContactSaga() {
  yield takeEvery(SEND_MESSAGE, onSendMessageContactSaga);
}

export function* contactMessageSaga() {
  yield all([fork(sendMessageContactSaga)]);
}
